export var config = {
  background: '#000',
  foreground: '#fff',
  selection: '#7d46fc3f',
  selectionMatch: '#7d46fc7f',
  cursor: '#7d46fc',
  dropdownBackground: '#0a0b0f',
  dropdownBorder: '#1e1d27',
  activeLine: '#00346eb0',
  matchingBracket: '#7d46fc7f',
  keyword: null,
  storage: null,
  variable: null,
  parameter: null,
  function: null,
  string: '#a8a8b1',
  constant: null,
  type: null,
  class: null,
  number: null,
  comment: '#2e2e37',
  heading: null,
  invalid: null,
  regexp: '#a8a8b1',
  tag: null
};